import { SubTrigger } from '@radix-ui/react-context-menu'
import { IconChevronRight } from '@tabler/icons-react'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
  type ReactNode,
} from 'react'
import { cn } from '#src/cn.ts'

export interface ContextMenuSubTriggerProps extends ComponentPropsWithoutRef<
  typeof SubTrigger
> {
  asChild?: boolean
  disabled?: boolean
  textValue?: string
  inset?: boolean
  /**
   * [data-state] - "open" | "closed"
   * [data-highlighted] - Present when highlighted
   * [data-disabled] - Present when disabled
   */
  className?: string
  children: ReactNode
}

export const ContextMenuSubTrigger = forwardRef<
  ElementRef<typeof SubTrigger>,
  ContextMenuSubTriggerProps
>(({ className, inset, children, ...delegated }, ref) => (
  <SubTrigger
    ref={ref}
    className={cn(
      'flex cursor-default select-none items-center rounded-sm px-2 py-1.5 text-sm outline-hidden focus:bg-accent focus:text-accent-foreground data-[state=open]:bg-accent data-[state=open]:text-accent-foreground',
      inset && 'pl-8',
      className
    )}
    {...delegated}
  >
    {children}
    <IconChevronRight className="ml-auto size-4" />
  </SubTrigger>
))
ContextMenuSubTrigger.displayName = SubTrigger.displayName
